import React from 'react';
import TextAvatar from '../Common/TextAvatar';
import functions from '../../util/functions';

const ProfileInfoItem = ({ iconClass, label, value, valueFallback = "N/A", iconColorClass }) => {
    return (
      <div className="col-6 mb-3 d-flex align-items-center">
        <i className={`fa ${iconClass} ${iconColorClass} mr-3`}></i>
        <div className='text-left'>
          <strong>{label}:</strong>
          <p className="mb-0 text-muted">{value || valueFallback}</p>
        </div>
      </div>
    );
  };
  

const StudentProfileInfo = ({profileInfo}) => {
    return (
        <div>
        <TextAvatar
            text={profileInfo.initials} 
            bgClass="secondary"
            image={profileInfo.image}
            size={"120px"} 
        />
        <h5 className="card-title mb-1">{profileInfo.full_name}</h5>
        <p className="text-muted mb-3">
            {profileInfo.status_name} {profileInfo.class?.class_name || ""}{" "}
            {profileInfo.status === "1" && (
            <i className="fa fa-circle-check text-success"></i>
            )}
        </p>
        

        <div className="row">
            <ProfileInfoItem
                iconClass="fa-id-badge"
                iconColorClass="text-primary"
                label="Reg No"
                value={profileInfo.reg_no}
            />
            <ProfileInfoItem
                iconClass="fa-venus-mars"
                iconColorClass="text-success"
                label="Gender"
                value={profileInfo.sex}
            />
            <ProfileInfoItem
                iconClass="fa-home"
                iconColorClass="text-warning"
                label="Residence"
                value={profileInfo.residence?.residence_name}
            />
           
            <ProfileInfoItem
                iconClass="fa-credit-card"
                iconColorClass="text-danger"
                label="Payment Code"
                value={profileInfo.other_reg || "Not Set"}
            />

            <ProfileInfoItem
                iconClass="fa-bullseye"
                iconColorClass="text-primary"
                label="Status"
                value={profileInfo.status_name}
            />

             <ProfileInfoItem
                iconClass="fa-tag"
                iconColorClass="text-primary"
                label="Class"
                value={`${profileInfo.class.class_name} - ${profileInfo.stream?.stream_name || 'No Stream'}`}
            />

             <ProfileInfoItem
                iconClass="fa-calendar"
                iconColorClass="text-primary"
                label="Birthday"
                value={profileInfo.DOB ? functions.formatDate(profileInfo.DOB) : "Not Set"}
            />

             <ProfileInfoItem
                iconClass="fa-calendar"
                iconColorClass="text-success"
                label="Admission Date"
                value={profileInfo.admission_date ? functions.formatDate(profileInfo.admission_date) : "Not Set"}
            />
          
            </div>
            
        </div>
    );
};

export default StudentProfileInfo;